export interface Toast {
  id: string;
  // #93: 'info' ist weder Erfolg noch Fehler — für den Auto-Sprung (EXE-1), der eine bewusst
  // gesetzte Suche/Filter überspringt und das melden muss, ohne einen Fehler vorzutäuschen.
  kind: 'success' | 'error' | 'info';
  message: string;
}

// Modul-Zähler statt Math.random/Date.now → deterministisch testbar.
let seq = 0;
let state: readonly Toast[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

function add(kind: Toast['kind'], message: string): void {
  seq += 1;
  state = [...state, { id: `t${seq}`, kind, message }];
  emit();
}

export const toast = {
  success(message: string): void {
    add('success', message);
  },
  error(message: string): void {
    add('error', message);
  },
  info(message: string): void {
    add('info', message);
  },
  dismiss(id: string): void {
    const next = state.filter((t) => t.id !== id);
    if (next.length === state.length) return; // nichts geändert -> keine neue Referenz/kein emit
    state = next;
    emit();
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot(): readonly Toast[] {
    return state;
  },
};
